export default __webpack_public_path__ + "static/media/pplogo.eac1608b.png";